import clsx from "clsx";
import { Minus, Plus } from "react-feather";

const ServingSizeControl = ({
  servingSize,
  onServingSizeChange,
  isDisabled = false,
  size = "sm",
  theme = "transparent",
}: {
  servingSize: number;
  onServingSizeChange: (servingSize: number) => void;
  isDisabled?: boolean;
  size?: "sm" | "lg";
  theme?: "transparent" | "dark" | "light";
}) => {
  const handleServingSizeChange = (direction = 1) => {
    const newServingSize = servingSize + direction;

    if (newServingSize > 0 && newServingSize < 9) {
      onServingSizeChange(newServingSize);
    }
  };

  return (
    <>
      <div
        className={clsx("ServingSizeControl", "flex items-center", {
          "space-x-2": size === "sm",
          "space-x-2.5": size === "lg",
        })}
      >
        <div
          className={clsx("ServingSizeControl__label", "font-body", {
            "text-xs": size === "sm",
            "text-sm": size === "lg",
          })}
        >
          Serves
        </div>
        <div
          className={clsx(
            "ServingSizeControl__controls",
            "group flex items-center justify-center rounded-full border",
            {
              "h-7 space-x-1.5 p-1": size === "sm",
              "h-8 space-x-2 p-1": size === "lg",
              "border-white/20 bg-zinc-800/20": theme === "transparent",
              "bg-zinc-50": theme === "light",
              "bg-zinc-100": theme === "dark",
            }
          )}
        >
          <_Control
            direction={-1}
            onClick={handleServingSizeChange}
            isDisabled={isDisabled}
            size={size}
            theme={theme}
          />

          <span
            className={clsx(
              "ServingSizeControl__servingSize",
              "font-normal tabular-nums",
              {
                "text-xs": size === "sm",
                "text-sm": size === "lg",
              }
            )}
          >
            {servingSize}
          </span>

          <_Control
            direction={1}
            onClick={handleServingSizeChange}
            isDisabled={isDisabled}
            size={size}
            theme={theme}
          />
        </div>
      </div>
    </>
  );
};

const _Control = ({ direction, onClick, isDisabled = false, size, theme }) => {
  const handleClick = () => {
    onClick(direction);
  };

  const Icon = direction === -1 ? Minus : Plus;

  return (
    <button
      onClick={handleClick}
      className={clsx(
        "ServingSizeControl__control",
        "flex items-center justify-center rounded-full transition group-hover:opacity-50 hover:!opacity-100",
        {
          "pointer-events-none opacity-50": isDisabled,
          "h-4 w-4": size === "sm",
          "h-6 w-6": size === "lg",
          "bg-zinc-800 text-white": theme === "dark",
          "bg-white text-zinc-800": theme === "light",
        }
      )}
    >
      <Icon
        className={clsx("stroke-[1.5]", {
          "h-3 w-3": size === "sm",
          "h-4 w-4": size === "lg",
        })}
      />
    </button>
  );
};

export default ServingSizeControl;
